var fa = {};
module['exports'] = fa;
fa.title = "Farsi";
fa.name = require("./name");



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/fa/index.js
// module id = 944
// module chunks = 0